document.addEventListener('DOMContentLoaded', function () {
  // Update Cookie Consent Privacy Policy Links
  const targetNode = document.body
  const config = { childList: true, subtree: true }
  const privacyPolicyUrl = '/policies/privacy-policy'

  const hasCompletedConsent = () => {
    return document.cookie.split(';').some((item) => {
      const cookie = item.trim().split('=')
      return cookie[0] === '_evidon_consent_cookie' || cookie[0] === '_evidon_suppress_notification_cookie'
    })
  }

  if (!hasCompletedConsent()) {
    const privacyConsentObserver = new MutationObserver((mutationsList, observer) => {
      const evidonBanner = document.getElementById('_evidon-message')
      const evidonPopup = document.getElementById('prc-message')
      const evidonPopupMenu = document.getElementById('evidon-prefdiag-nav-1')

      // Cookie Consent Banner
      if (evidonBanner) {
        const privacyPolicyLinks = evidonBanner.querySelectorAll('a[href*="https://privacy.umusic.com"]')
        if (privacyPolicyLinks) {
          privacyPolicyLinks.forEach(link => {
            link.href = privacyPolicyUrl
          })
        }
      }
      // Cookie Consent Popup
      if (evidonPopup) {
        const privacyPolicyLinks = evidonPopup.querySelectorAll('a[href*="https://privacy.umusic.com"]')
        if (privacyPolicyLinks) {
          privacyPolicyLinks.forEach(link => {
            link.href = privacyPolicyUrl
          })
        }
      }
      // Cookie Consent Popup 2nd link
      if (evidonPopupMenu) {
        evidonPopupMenu.addEventListener('click', (event) => {
          event.stopPropagation()
          window.open(privacyPolicyUrl, '_blank')
        }, true)
      }
    })

    // Begin observing the target node for configured mutations
    privacyConsentObserver.observe(targetNode, config)
  }
})
  // End - Update Cookie Consent Privacy Policy Links
